import { SplatControlConfig } from "./splat-control-config.model";
import { Control } from "../../business-objects/control/control.model";

export class ControlSplat extends Control {
    config: SplatControlConfig;
}



// WEBPACK FOOTER //
// ./src/vas/controls/splat/splat-control.model.ts